import React from "react";
import IcecastMetadataPlayer from "icecast-metadata-player";
import Prev from "../../../../../../assets/icon/Prev";
import Next from "../../../../../../assets/icon/Next";
import ControlButton from "../../../components/ControlButton";

interface Props {
  type?: string;
  player: IcecastMetadataPlayer;
}

const ControlPlayer: React.FC<Props> = ({ player }) => {
  return (
    <>
      <div className="flex justify-center items-center w-full pb-7">
        <div className="cursor-pointer">
          <ControlButton player={player} />
        </div>
      </div>
    </>
  );
};

export default ControlPlayer;
